/**
 * Clean Menu System
 * Handles mobile menu toggle with smooth animations
 */

class CleanMenu {
    constructor() {
        this.burger = document.getElementById('menuBurger');
        this.panel = document.getElementById('mobilePanel');
        this.overlay = document.getElementById('menuOverlay');
        this.body = document.body;
        this.isOpen = false;
        
        this.init();
    }
    
    init() {
        if (!this.burger || !this.panel) return;
        
        // Burger click
        this.burger.addEventListener('click', () => this.toggle());
        
        // Overlay click
        if (this.overlay) {
            this.overlay.addEventListener('click', () => this.close());
        }
        
        // Close on escape key
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.isOpen) {
                this.close();
            }
        });
        
        // Close on link click
        const links = this.panel.querySelectorAll('.mobile-panel-link');
        links.forEach(link => {
            link.addEventListener('click', (e) => {
                // Don't close immediately for form buttons
                if (link.tagName === 'BUTTON' && link.type === 'submit') {
                    // Let form submission happen first
                    return;
                }
                setTimeout(() => this.close(), 200);
            });
        });
    }
    
    toggle() {
        if (this.isOpen) {
            this.close();
        } else {
            this.open();
        }
    }
    
    open() {
        this.isOpen = true;
        this.burger.classList.add('is-active');
        this.burger.setAttribute('aria-expanded', 'true');
        this.panel.classList.add('is-active');
        this.overlay?.classList.add('is-active');
        this.body.classList.add('menu-open');
    }
    
    close() {
        this.isOpen = false;
        this.burger.classList.remove('is-active');
        this.burger.setAttribute('aria-expanded', 'false');
        this.panel.classList.remove('is-active');
        this.overlay?.classList.remove('is-active');
        this.body.classList.remove('menu-open');

        // Ensure body overflow is restored
        document.body.style.overflow = '';
    }
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', () => {
    new CleanMenu();
});

export default CleanMenu;